import { NavigateWithThread, FocusDashboard, Profile, EvaluationAnalysisPage } from '@yeshuman/sdk'
import { Routes, Route, useParams } from 'react-router-dom'
import { InterviewerCandidatesPage } from '../../../components/interviewer/interviewer-candidates-page'
import { InterviewerInterviewsPage } from '../../../components/interviewer/interviewer-interviews-page'
import { InterviewerSessionPage } from '../../../components/interviewer/interviewer-session-page'

interface InterviewerRoutesProps {
  onStartConversation?: (message: string) => void
}

function InterviewerEvaluationRoute() {
  const { evaluationId } = useParams<{ evaluationId: string }>()
  if (!evaluationId) {
    return <NavigateWithThread to="/interviewer/candidates" />
  }
  return <EvaluationAnalysisPage evaluationId={evaluationId} context={{ kind: 'recruiter-talent' }} />
}

export function InterviewerRoutes({ onStartConversation }: InterviewerRoutesProps) {
  return (
    <Routes>
      <Route
        index
        element={
          <FocusDashboard focus="interviewer" onStartConversation={onStartConversation} />
        }
      />
      <Route path="profile" element={<Profile />} />
      <Route path="candidates" element={<InterviewerCandidatesPage />} />
      <Route path="interviews" element={<InterviewerInterviewsPage />} />
      <Route path="session" element={<InterviewerSessionPage />} />
      <Route path="session/:sessionId" element={<InterviewerSessionPage />} />
      <Route path="evaluations/:evaluationId" element={<InterviewerEvaluationRoute />} />
      <Route path="*" element={<NavigateWithThread to="" />} />
    </Routes>
  )
}
